import React from 'react';
import { TimerIcon, MapIcon } from 'lucide-react';
interface RouteSummaryProps {
  summary: {
    distance: string;
    duration: string;
  };
}
const RouteSummary: React.FC<RouteSummaryProps> = ({
  summary
}) => {
  return <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-136">
      <h3 className="font-semibold text-blue-800 mb-2" data-id="element-137">Route Summary</h3>
      <div className="flex items-center text-blue-700 mb-2" data-id="element-138">
        <MapIcon className="w-5 h-5 mr-2" data-id="element-139" />
        <span data-id="element-140">Total Distance: {summary.distance}</span>
      </div>
      <div className="flex items-center text-blue-700" data-id="element-141">
        <TimerIcon className="w-5 h-5 mr-2" data-id="element-142" />
        <span data-id="element-143">Total Duration: {summary.duration}</span>
      </div>
    </div>;
};
export default RouteSummary;